<div class="banner detail-banner">
    <div class="banner-bg"></div>
    <div class="banner-caption">
        <div class="main-logo">
            <a href="/"></a>
        </div>
        <div class="main-text">
            <p class="head">Başvuru Alımları</p>
            <p class="date">Tamamlandı</p>
        </div>
    </div>
</div>